import * as Yup from "yup";

import { STATUS } from "@/constant/statusConstants";

const getRefreshScheduleSchema = () =>
  Yup.object().shape({
    hour: Yup.string()
      .label("Hour")
      .required()
      .matches(/^([0-1]?[0-9]|2[0-3])$/, "Hour must be between 00 and 23."),
    minute: Yup.string()
      .label("Minute")
      .required()
      .matches(/^[0-5]?[0-9]$/, "Minute must be between 00 and 59."),
    status: Yup
      .string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
  });

export default getRefreshScheduleSchema;
